/**
 * 日付文字列を画面表示用にフォーマットする関数
 * @param {string} dateTimeString - 日付文字列（例: "2023-10-05T14:48:00" または "2023-10-05"）
 */
export const formatDateForDisplay = (dateTimeString) => {
    if (!dateTimeString) return '';
    
    // 日付部分を取得
    let datePart = '';
    
    if (dateTimeString.includes('T')) {
        datePart = dateTimeString.split('T')[0];
    } else {
        datePart = dateTimeString;
    }
    
    // ハイフン形式をスラッシュ形式に変換（画面表示用）
    if (datePart.includes('-')) {
        return datePart.replace(/-/g, '/');
    }
    
    return datePart;
}

/**
 * 日時文字列を画面表示用にフォーマットする関数
 * @param {string} dateTimeString - 日付文字列（例: "2023-10-05T14:48:00"）
 */
export const formatDateTimeForDisplay = (dateTimeString) => {
    if (!dateTimeString) return '';
    const date = new Date(dateTimeString);
    if (Number.isNaN(date.getTime())) return dateTimeString;
    return date.toLocaleString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
};

/**
 * 日付文字列をAPI送信用にフォーマットする関数
 * @param {string} dateTimeString - 日付文字列（例: "2023-10-05"）
 */
export const formatDateForApi = (dateTimeString) => {
    return (dateTimeString ?? '').replace(/-/g, '/');
}

/**
 * 日付文字列（yyyy/MM/dd）をAPI送信用の開始日時文字列に変換する
 * @param {string} dateString - yyyy/MM/dd 形式の日付文字列
 * @returns {string} yyyy-MM-ddT00:00:00 形式の文字列
 */
export const formatDateForApiStart = (dateString) =>
    (dateString ?? '').replace(/\//g, '-') + 'T00:00:00';

/**
 * 日付文字列（yyyy/MM/dd）をAPI送信用の終了日時文字列に変換する
 * @param {string} dateString - yyyy/MM/dd 形式の日付文字列
 * @returns {string} yyyy-MM-ddT23:59:59 形式の文字列
 */
export const formatDateForApiEnd = (dateString) =>
    (dateString ?? '').replace(/\//g, '-') + 'T23:59:59';